import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const Box = styled.div`
  width: 90%;
  max-width: 1000px;
  position: relative;
  padding: 0 15px;
  margin: 20px auto;
  // background-color: #78b08f;
  border-radius: 10px;
  padding-bottom: 40px;
  color: #333;
  text-align: center;
  display: flex;
  flex-direction: column;
  font-size: 1.2em;
  box-sizing: border-box;

  @media only screen and (max-width: 600px) {
    width: 100%;
    margin: 0 auto;
    border-radius: 0;
  }
`

const CloseBtn = styled.div`
  position: absolute;
  top: 5px;
  right: 15px;
  font-size: 42px;
  cursor: pointer;

  a {
    text-decoration: none;
    color: inherit;
  }
`

const ContentBox = styled.div`
  width: 80%;
  margin: 0 auto;

  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`

const Modal = ({ title, onCloseLink='/', className, children }) => {
  return (
    <Box>
      <h1>{title}</h1>
      <CloseBtn>
        <Link to={onCloseLink}>
          &times;
        </Link>
      </CloseBtn>
      <ContentBox className={className}>
        {children}
      </ContentBox>
   </Box>
  )
}

export default Modal
